import React from "react";
import { BrowserRouter, Routes, Route, } from 'react-router-dom'
import LandingPage from "./views/LandingPage.js";
import LoginPage from "./views/LoginPage.js";
import PrivacyPolicy from "./views/PrivacyPolicy.js";
import AboutUs from "./views/AboutUs";
import AuthLoading from './views/AuthLoading';
import { Provider } from "react-redux";
import ProtectedRoute from './ProtectedRoute';
import MyProfile from './views/MyProfile';
import BookingHistory from './views/BookingHistory';
import Dashboard from './views/Dashboard';
import CarTypes from './views/CarTypes';
import AddBookings from './views/AddBookings';
import Promos from './views/Promos';
import Users from './views/Users';
import CustomerDetails from "views/CustomerDetails.js";
import Notifications from './views/Notifications';
import Settings from './views/Settings.js';
import Complain from "views/Complain.js";
import AddMoney from "./views/AddMoney";
import Withdraws from './views/Withdraws';
import AllReports from "./views/AllReports";
import { FirebaseProvider, store } from "common";
import { FirebaseConfig } from './config/FirebaseConfig';
import { GoogleMapApiConfig } from './config/GoogleMapApiConfig';
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import ContactUs from "./views/ContactUs";
import UserWallet from "./views/UserWallet";
import CarsList from "./views/CarsList";
import { ThemeProvider } from '@mui/styles';
import { createTheme } from '@mui/material';
import { useJsApiLoader } from '@react-google-maps/api';
import TermCondition from "views/TermCondition.js";
import { GoogleOAuthProvider } from '@react-oauth/google';
import { webClientId } from "config/ClientIds.js";
import { HelmetProvider } from "react-helmet-async";
import Sos from './views/Sos';
import DriverDetails from "views/DriverDetails.js";
import Error from "views/Error.js";
import BookingDetails from "views/BookingDetails.js";
import UserDocuments from "views/UserDocuments.js";
import AddNotifications from "views/AddNotifications.js";
import EditPromo from "views/EditPromo.js";
import EditCar from "views/EditCar.js";
import EditCarType from "views/EditCarType.js";
import EditUser from "views/EditUser.js";
import PaymentSettings from "views/PaymentSettings.js";
import ContainerYards from "views/ContainerYards.js";
import AdminChats from "views/AdminChats.js";
import ResetPassword from "views/ResetPassword.js";
import DataImportExport from "views/DataImportExport.js";
import AdditionalFees from "views/AdditionalFees.js";
import EmptyContainerReturns from "views/EmptyContainerReturns.js";
import WorkflowConfiguration from "views/WorkflowConfiguration.js";
import BookingOrdersForBid from "views/BookingOrdersForBid.js";
import AdminBidMonitoring from "views/AdminBidMonitoring.js";
import WebsiteManagement from "views/WebsiteManagement.js";
import WebsitePageSettings from "views/WebsitePageSettings.js";
const libraries = ['geometry','drawing','places'];

const humanizeTranslationKey = (key) => String(key || "")
  .replace(/([a-z0-9])([A-Z])/g, "$1 $2")
  .replace(/[_-]+/g, " ")
  .replace(/\s+/g, " ")
  .trim()
  .replace(/\b\w/g, (char) => char.toUpperCase())
  .replace(/\bId\b/g, "ID")
  .replace(/\bOtp\b/g, "OTP")
  .replace(/\bGps\b/g, "GPS")
  .replace(/\bBl\b/g, "BL")
  .replace(/\bUrl\b/g, "URL");

i18n
.use(initReactI18next) 
.init({
    resources: {},
    fallbackLng: "en",
    ns: ["translations"],
    defaultNS: "translations",
    parseMissingKeyHandler: humanizeTranslationKey,
    interpolation: {
        escapeValue: false
    }
});

function App() {

  useJsApiLoader({
    id: 'google-map',
    googleMapsApiKey: GoogleMapApiConfig + "&loading=async",
    libraries
  })

  const theme = createTheme()

  return (
    <HelmetProvider>
    <Provider store={store}>
      <FirebaseProvider config={FirebaseConfig}>
        <GoogleOAuthProvider clientId={webClientId}>
        <ThemeProvider theme={theme}>
          <AuthLoading>
           <BrowserRouter>
              <Routes>
                <Route path="/dashboard" element={<ProtectedRoute permit={"admin,fleetadmin"} moduleKey="dashboard"><Dashboard /></ProtectedRoute>}/>
                <Route path="/bookings" element={<ProtectedRoute permit={"customer,admin,driver,fleetadmin"} moduleKey="bookingHistory"><BookingHistory /></ProtectedRoute>}/>
                <Route path="/booking-orders-for-bid" element={<ProtectedRoute permit={"admin,fleetadmin"} moduleKey="bookingOrdersForBid"><BookingOrdersForBid /></ProtectedRoute>}/>
                <Route path="/admin-bid-monitoring" element={<ProtectedRoute permit={"admin"} moduleKey="adminBidMonitoring"><AdminBidMonitoring /></ProtectedRoute>}/>
                <Route path="/bookings/bookingdetails/:id" element={<ProtectedRoute permit={"customer,admin,driver,fleetadmin"} moduleKey="bookingHistory"><BookingDetails /></ProtectedRoute>}/>
                <Route path="/empty-container-returns" element={<ProtectedRoute permit={"customer,admin,driver,fleetadmin"} moduleKey="emptyContainerReturn"><EmptyContainerReturns /></ProtectedRoute>}/>
                <Route path="/profile" element={<ProtectedRoute permit={"customer,admin,driver,fleetadmin"} moduleKey="profile"><MyProfile /></ProtectedRoute>}/>
                <Route path="/cartypes" element={<ProtectedRoute permit={"admin"} moduleKey="vehicleType"><CarTypes /></ProtectedRoute>}/>
                <Route path="/containeryards" element={<ProtectedRoute permit={"admin"} moduleKey="containerYard"><ContainerYards /></ProtectedRoute>}/>
                <Route path="/additionalfees" element={<ProtectedRoute permit={"admin"} moduleKey="additionalFeesTitle"><AdditionalFees /></ProtectedRoute>}/>
                <Route path="/adminchats" element={<ProtectedRoute permit={"admin"} moduleKey="chatProof"><AdminChats /></ProtectedRoute>}/>
                <Route path="/data-import-export" element={<ProtectedRoute permit={"admin"} moduleKey="dataImportExport"><DataImportExport /></ProtectedRoute>}/>
                <Route path="/cars" element={<ProtectedRoute permit={"admin,fleetadmin,driver"} moduleKey="carsAndDrivers"><CarsList /></ProtectedRoute>}/>
                <Route path="/addbookings" element={<ProtectedRoute permit={"admin,fleetadmin,customer"} moduleKey="addBookings"><AddBookings /></ProtectedRoute>}/>
                <Route path="/promos" element={<ProtectedRoute permit={"admin"} moduleKey="promos"><Promos /></ProtectedRoute>}/>
                <Route path="/users/:id" element={<ProtectedRoute permit={"admin,fleetadmin"} moduleKey="users"><Users /></ProtectedRoute>}/>
                <Route path="/users/customerdetails/:id" element={<ProtectedRoute permit={"admin,fleetadmin"} moduleKey="users"><CustomerDetails/></ProtectedRoute>}/>
                <Route path="/users/driverdetails/:id" element={<ProtectedRoute permit={"admin,fleetadmin"} moduleKey="users"><DriverDetails/></ProtectedRoute>}/>
                <Route path="/users/userdocuments/:rId/:id" element={<ProtectedRoute permit={"admin,fleetadmin"} moduleKey="users"><UserDocuments/></ProtectedRoute>} />  
                <Route path="/notifications" element={<ProtectedRoute permit={"admin"} moduleKey="pushNotifications"><Notifications /></ProtectedRoute>}/>
                <Route path="/addtowallet" element={<ProtectedRoute permit={"admin"} moduleKey="addToWallet"><AddMoney /></ProtectedRoute>}/>
                <Route path="/userwallet" element={<ProtectedRoute permit={"customer,driver,fleetadmin"} moduleKey="myWallet"><UserWallet /></ProtectedRoute>}/>
                <Route path="/withdraws" element={<ProtectedRoute permit={"admin"} moduleKey="withdraws"><Withdraws /></ProtectedRoute>}/>
                <Route path="/sos" element={<ProtectedRoute permit={"admin"} moduleKey="ec"><Sos /></ProtectedRoute>}/>
                <Route path="/complain" element={<ProtectedRoute permit={"admin"} moduleKey="complaint"><Complain /></ProtectedRoute>}/>
                <Route path="/allreports" element={<ProtectedRoute permit={"admin,fleetadmin"} moduleKey="reports"><AllReports /></ProtectedRoute>}/>
                <Route path="/settings" element={<ProtectedRoute permit={"admin"} moduleKey="settings"><Settings /></ProtectedRoute>}/>
                <Route path="/workflow-configuration" element={<ProtectedRoute permit={"admin"} moduleKey="workflowConfiguration"><WorkflowConfiguration /></ProtectedRoute>}/>
                <Route path="/paymentsettings" element={<ProtectedRoute permit={"admin"} moduleKey="paymentSettings"><PaymentSettings /></ProtectedRoute>}/>
                <Route path="/website-management" element={<ProtectedRoute permit={"admin"} moduleKey="settings"><WebsiteManagement /></ProtectedRoute>}/>
                <Route path="/website-management/:pageKey" element={<ProtectedRoute permit={"admin"} moduleKey="settings"><WebsitePageSettings /></ProtectedRoute>}/>
                <Route path="/contact-us" element={<ContactUs />} />
                <Route path="/about-us" element={<AboutUs />} />
                <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                <Route path="/term-condition" element={<TermCondition />} />
                <Route path="/login" element={<LoginPage />} />
                <Route path="/reset-password" element={<ResetPassword />} />
                <Route path="/__/auth/action" element={<ResetPassword />} />
                <Route path="/users/edituser/:usertype" element={<ProtectedRoute permit={"admin,fleetadmin"} moduleKey="users"><EditUser/></ProtectedRoute>}/>
                <Route path="/users/edituser/:usertype/:id" element={<ProtectedRoute permit={"admin,fleetadmin"} moduleKey="users"><EditUser/></ProtectedRoute>}/>
                <Route path="/notifications/addnotifications" element={<ProtectedRoute permit={"admin"} moduleKey="pushNotifications"><AddNotifications/></ProtectedRoute>}/>
                <Route path="/cars/editcar" element={<ProtectedRoute permit={"admin,fleetadmin,driver"} moduleKey="carsAndDrivers"><EditCar/></ProtectedRoute>}/>
                <Route path="/cars/editcar/:id" element={<ProtectedRoute permit={"admin,fleetadmin,driver"} moduleKey="carsAndDrivers"><EditCar/></ProtectedRoute>}/>
                <Route path="/promos/editpromo" element={<ProtectedRoute permit={"admin"} moduleKey="promos"><EditPromo/></ProtectedRoute>}/>
                <Route path="/promos/editpromo/:id" element={<ProtectedRoute permit={"admin"} moduleKey="promos"><EditPromo/></ProtectedRoute>}/>
                <Route path="/contact-us" element={<ContactUs />} />
                <Route path="/cartypes/editcartype" element={<ProtectedRoute permit={"admin"} moduleKey="vehicleType" ><EditCarType/></ProtectedRoute>} />
                <Route path="/cartypes/editcartype/:id" element={<ProtectedRoute permit={"admin"} moduleKey="vehicleType"><EditCarType/></ProtectedRoute>}/>
                <Route path="/*" element={<Error/>} />
                <Route path="/" element={<LandingPage />} />
              </Routes>
            </BrowserRouter>
          </AuthLoading>
        </ThemeProvider>
        </GoogleOAuthProvider>
      </FirebaseProvider>
    </Provider>
    </HelmetProvider>
  );
}

export default App;

